import PropTypes from 'prop-types';
import React from 'react';
import FieldHelperText from '~components/field-helper-text';
import DayPickerInput from './day-picker-input';

const FormControlDayPickerInput = React.forwardRef((props, ref) => {
  const {
    error,
    placeholder,
    InputProps,
    FieldHelperTextProps,
    className,
    style,
    ...otherProps
  } = props;
  return (
    <div style={style} className={className} ref={ref}>
      <DayPickerInput InputProps={{ error: !!error, placeholder, ...InputProps }} {...otherProps} />
      <FieldHelperText {...FieldHelperTextProps}>{error}</FieldHelperText>
    </div>
  );
});

FormControlDayPickerInput.propTypes = {
  error: PropTypes.string,
  placeholder: PropTypes.string,
  // props applied to Input
  InputProps: PropTypes.object,
  // props applied to FieldHelperText
  FieldHelperTextProps: PropTypes.object,
  className: PropTypes.string,
  style: PropTypes.object,
  // otherProps will be applied to DayPickerInput
};

FormControlDayPickerInput.defaultProps = {
  placeholder: undefined,
  error: undefined,
  InputProps: {},
  FieldHelperTextProps: {},
  className: undefined,
  style: {},
};

export default FormControlDayPickerInput;
